import { CentraOrder } from "@/lib/checkout/payment/usePaymentResult";
import getRecipePdf from "@/lib/cloudinary/getRecipePdf";
import { Order, Orders } from "@/srpc/routes/users.router";
import { formatDateToNorwegianLocale } from "../ordrehistorikk/UI/ClientUI";
import { Recipe } from "./UI/ClientUI";

/** Create Recipe object */
const transformItemToRecipe = async (
  item: NonNullable<CentraOrder["items"]>[number]
): Promise<Recipe> => {
  const pdfResult = await getRecipePdf({
    cloudinaryId: item.product?.pr_cloudinary_id_cloudinaryId,
  });

  return {
    gallery: {
      image: {
        uri: item?.product?.media?.["700x0"]?.[0] || "",
        alt: "",
      },
    },
    description: {
      sku: item?.product?.sku,
      name: item?.product?.name,
    },
    download: {
      uri: pdfResult.url || "",
      lastModified: formatDateToNorwegianLocale(item.product?.modifiedAt),
    },
  };
};

/** Get products in order which is type recipe and return Recipes */
const processOrderItems = async (order: Order): Promise<Recipe[]> => {
  const recipeItems = order.items
    ?.filter((item) => item.product?.pr_product_type_type === "recipe")
    .map((item) => transformItemToRecipe(item));

  return recipeItems ? Promise.all(recipeItems) : [];
};

export const getItemsWithTypeRecipe = async (
  data: Orders | undefined
): Promise<Recipe[]> => {
  if (!data) return [];

  const itemsWithTypeRecipe = await Promise.all(
    data.map((order) => processOrderItems(order))
  );

  return itemsWithTypeRecipe.flat();
};
